import { UserModel } from '@app/domain/UserModel';

export const persistToken = (token: string): void => {
  localStorage.setItem('access_token', token);
  localStorage.setItem('auth_token', token); // Keep for backward compatibility
};

export const readToken = (): string | null => {
  return localStorage.getItem('access_token') || localStorage.getItem('auth_token');
};

export const persistUser = (user: UserModel): void => {
  localStorage.setItem('user', JSON.stringify(user));
};

export const readUser = (): UserModel | null => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const deleteToken = (): void => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('auth_token');
};

export const deleteUser = (): void => localStorage.removeItem('user');
